<script>
	import RadioGroup from "./RadioGroup.svelte";

	export let name;
	export let label;
	export let sublabel = null;
	export let value;

	export let required;
	export let disabled = null;
	export let labelWithTooltip = null;
	export let tooltipText = null;
	export let labelBeforeTooltip = null;
	export let labelAfterTooltip = null;

	const yesNoOptions = [
		{ label: "Yes", value: "Yes" },
		{ label: "No", value: "No" }
	];
</script>

<RadioGroup
	{disabled}
	{required}
	{name}
	{label}
	{sublabel}
	{tooltipText}
	{labelWithTooltip}
	{labelBeforeTooltip}
	{labelAfterTooltip}
	bind:value
	optionList={yesNoOptions}
	labelProperty="label"
	valueProperty="value"
></RadioGroup>
